var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-layout"},[_c('c-header-lv1',{attrs:{"hShow":_vm.showHeader,"hotTags":_vm.hotTags},on:{"focusInput":_vm.onFocusInput,"cancelFocus":_vm.onCancelFocus}}),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }